import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleMultiHeaderTable from "../../../../../../modules/SimpleMultiHeaderTable";
import Api from "../../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import { HttpStatus } from "../../../../../common/Constants";
import { mapToObjectDDL } from "../../../../../common/mapper";
import { monthOptions, yearOptions } from "../../../config";
import { getDaysInMonth, groupHeaders, tableColumns, generatePayloadPrint } from "./config";
import { saveAs } from "file-saver";
export default class LaporanServiceHarian extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));

    this.state = {
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      mechanicName: null,
      mechanicOptions: [],
      dataTable: [],
    };
  }

  componentDidMount() {
    this.fetchDataMechanic();
  }

  componentDidUpdate(prevProps, prevState) {
    const currCabang = this.props.kodeCabang?.value;
    const prevCabang = prevProps?.kodeCabang?.value;
    if (currCabang !== prevCabang) {
      this.fetchDataMechanic();
    }
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  handlePrint = async () => {
      const { onTriggerLoading, setError } = this.props;
      const { dataTable } = this.state;
      onTriggerLoading();
      const title = "Laporan Servis Harian by Mekanik";
      const fileName = title.split(" ").join("_");
  
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateAdvancedExcelFromPayload,
        setError: setError,
        menuName: "Dashboard Kabeng Keatas - Laporan Service Harian",
        args: generatePayloadPrint(dataTable),
      });
      onTriggerLoading();
      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, fileName + ".xlsx");
      }
    };

  fetchDataMechanic = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA")
        .getMechanicForDropDownListDashboard,
      setError: setError,
      menuName: "Dashboard Kabeng Keatas - Laporan Servis Harian by Mekanik",
      args: [kodeCabang?.value],
    });

    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res?.data?.data?.map((item) =>
        mapToObjectDDL(item.mechanicName, item.idEmployee),
      );
      this.setState(
        {
          mechanicOptions: data,
          mechanicName: data[0],
        },
        () => {
          this.fetchData();
        },
      );
    }
  };

  fetchData = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    const { mechanicName, year, month } = this.state;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanServisHarianH23,
      setError: setError,
      menuName: "Dashboard Kabeng Keatas - Laporan Servis Harian by Mekanik",
      args: {
        listCabang: [kodeCabang?.value],
        year: year?.value,
        month: month?.value,
        mechanicEmployeeId: mechanicName?.value,
      },
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: this.constructData(res.data.data),
      });
    }
  };

  constructData = (data) => {
    const { month, year } = this.state;

    const daysWithData = getDaysInMonth(year?.value, month?.value - 1);
    const tableData = daysWithData.map((day, index) => ({
      tanggal: day,

      unitEntriHarian: data.unitEntri.harian[index + 1],
      unitEntriAkumulasi: data.unitEntri.akumulasi[index + 1],

      unitNonServisHarian: data.unitNonServis.harian[index + 1],
      unitNonServisAkumulasi: data.unitNonServis.akumulasi[index + 1],
      unitNonServiceUePercent: data.unitServis.drUePercentage[index + 1],

      unitServiceHarian: data.unitServis.harian[index + 1],
      unitServiceAkumulasi: data.unitServis.akumulasi[index + 1],
      unitServiceUePercent: data.unitServis.drUePercentage[index + 1],

      totalNonKpbHarian: data.totalNonKpb.harian[index + 1],
      totalNonKpbAkumulasi: data.totalNonKpb.akumulasi[index + 1],
      totalNonKpbUePercent: data.totalKpb.drUePercentage[index + 1],
      totalNonKpbUsPercent: data.totalKpb.drUsPercentage[index + 1],

      totalKpbHarian: data.totalKpb.harian[index + 1],
      totalKpbAkumulasi: data.totalKpb.akumulasi[index + 1],
      totalKpbUePercent: data.totalKpb.drUePercentage[index + 1],
      totalKpbUsPercent: data.totalKpb.drUsPercentage[index + 1],

      kpb1Harian: data.kpb1.harian[index + 1],
      kpb1Akumulasi: data.kpb1.akumulasi[index + 1],
      kpb1TotalPercent: data.kpb1.drTotKpbPercentage[index + 1],

      kpb2Harian: data.kpb2.harian[index + 1],
      kpb2Akumulasi: data.kpb2.akumulasi[index + 1],
      kpb2TotalPercent: data.kpb1.drTotKpbPercentage[index + 1],

      kpb3Harian: data.kpb3.harian[index + 1],
      kpb3Akumulasi: data.kpb3.akumulasi[index + 1],
      kpb3TotalPercent: data.kpb1.drTotKpbPercentage[index + 1],
    }));

    return tableData;
  };

  render() {
    const { month, year, mechanicOptions, mechanicName, dataTable } =
      this.state;
    return (
      <React.Fragment>
        <FlexView
          style={{ gap: "20px", alignItems: "center" }}
          className="margin-bottom-20px"
        >
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_mechanic"
            box="search"
            isClearable
            name="mechanicName"
            containerclassname="width width-250px"
            placeholder="Mekanik"
            menuPosition="fixed"
            options={mechanicOptions}
            value={mechanicName}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleMultiHeaderTable
          data={dataTable}
          columns={tableColumns}
          groupHeaders={groupHeaders}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton text="CETAK" onClick={() => this.handlePrint()} />
        </FlexView>
      </React.Fragment>
    );
  }
}
